module.exports = __webpack_public_path__ + "static/takumi-06c333bd3ff40a5f3af40c648c8f31ca.jpg";